import { getFunctions } from 'firebase/functions';
import { initializeFirestore, persistentLocalCache, persistentSingleTabManager } from 'firebase/firestore';
import { isChinaUser } from './firebaseProxy';

/**
 * Get Firebase Functions instance with custom domain for China users if needed
 * @param {Object} app - Firebase app instance
 * @returns {Object} Firebase Functions instance
 */
export const getFirebaseFunctions = (app) => {
  const isChina = isChinaUser();
  if (process.env.NODE_ENV === 'development' || !isChina) {
    return getFunctions(app);
  }
  return getFunctions(app, 'https://china-orgs-ws.labox-apps.com/labox-ws/europe-west1');
};

/**
 * Get Firestore settings based on environment and user location
 * @param {Object} baseSettings - Base Firestore settings
 * @param {string} host - Host for emulator (default: 'localhost')
 * @returns {Object} Firestore settings
 */
export const getFirestoreSettings = (baseSettings, host = 'localhost') => {
  const isChina = isChinaUser();
  if (process.env.NODE_ENV === 'development') {
    return {
      ...baseSettings,
      host: `${host}:4401`,
      ssl: false,
    };
  }
  if (isChina) {
    return {
      ...baseSettings,
      host: 'china-orgs-ws.labox-apps.com',
      ssl: true,
    };
  }
  return baseSettings;
};

/**
 * Initialize Firestore with proper settings
 * @param {Object} firebaseApp - Firebase app instance
 * @param {string} host - Host for emulator (default: 'localhost')
 * @returns {Object} Firestore instance
 */
export const initializeFirestoreWithSettings = (firebaseApp, host = 'localhost') => {
  const baseSettings = {
    localCache: persistentLocalCache({
      tabManager: persistentSingleTabManager({
        experimentalForceOwningTab: true,
        // eslint-disable-next-line no-undef
        forceOwnership: !globalThis.localStorage,
      }),
    }),
  };

  const savedSetting = localStorage.getItem('forceLongPolling');
  const forceLongPolling = savedSetting === 'true';
  if (forceLongPolling) {
    baseSettings.experimentalForceLongPolling = true;
  } else {
    baseSettings.experimentalAutoDetectLongPolling = true;
  }

  const fsSettings = getFirestoreSettings(baseSettings, host);
  return initializeFirestore(firebaseApp, fsSettings);
};
